export default __webpack_public_path__ + "static/media/element_16.3fd40f23.avif";